// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./client/react/Admin/scss/core/_dropdown-menu-right.scss
// module id = 556
// module chunks = 0